<template>
  <div class="outline-container">
    <div class="outline-header">
      <div>{{ outlineData.title }}</div>
    </div>
    <div class="chapters-tree">
      <el-scrollbar class="chapters-scrollbar">
        <div class="title-container">
          <div class="chapter-item">
            <span>主题</span>
          </div>
          <div class="chapter-item">
            <span>目录</span>
          </div>
          <div
            class="chapter-item no-border"
            v-for="chapter in outline.chapterContents"
            :key="chapter.uuid"
          ></div>
          <div
            class="chapter-item"
            v-for="chapter in outlineList"
            :key="chapter.uuid"
          >
            <span>{{ chapter.level === 1 ? "章节" : "内页" }}</span>
          </div>
        </div>
        <div class="icon-container">
          <div class="icon-root icon-item">
            <span></span>
          </div>
          <div class="icon-root icon-item">
            <span></span>
          </div>
          <div
            class="icon-chapter icon-item"
            v-for="chapter in outline.chapterContents"
            :key="chapter.uuid"
          >
            <span></span>
          </div>
          <div
            class="icon-item"
            :class="[chapter.level === 1 ? 'icon-root' : 'icon-chapter']"
            v-for="chapter in outlineList"
            :key="chapter.uuid"
          >
            <span :style="setIconStyle(chapter.level)"></span>
            <span
              class="line"
              :style="setLineStyle(chapter.level)"
              v-if="chapter.level !== 1"
            ></span>
          </div>
        </div>
        <div class="tree-container">
          <div class="title chapter-content" :title="outline.title">
            {{ outline.title }}
          </div>
          <div class="title chapter-content">目录</div>
          <div
            class="chapter-item chapter-content"
            v-for="(chapter, index) in outline.chapterContents"
            :key="chapter.uuid"
            @mouseenter="selectChapter(chapter)"
            @mouseleave="clearChapter"
          >
            <span class="chapter-title" :title="chapter.chapterTitle">{{
              chapter.chapterTitle
            }}</span>
            <span
              class="chapter-actions"
              v-show="currentChapter.chapterTitle === chapter.chapterTitle"
            >
              <span
                class="action up"
                data-track-text="上移大纲节点"
                aria-label="上移大纲节点"
                v-show="index !== 0"
                @click.stop="
                  moveUp({
                    chapter,
                    parentChapters: outline.chapterContents,
                    index,
                  })
                "
              ></span>
              <span
                class="action down"
                data-track-text="下移大纲节点"
                aria-label="下移大纲节点"
                v-show="index !== outline.chapterContents.length - 1"
                @click.stop="
                  moveDown({
                    chapter,
                    parentChapters: outline.chapterContents,
                    index,
                  })
                "
              ></span>
              <span
                class="action delete el-icon-customerarchivesrecycleBin"
                data-track-text="删除大纲节点"
                aria-label="删除大纲节点"
                @click.stop="
                  deleteNode({
                    chapter,
                    parentChapters: outline.chapterContents,
                    index,
                  })
                "
              >
              </span>
            </span>
          </div>
          <ul
            class="root"
            v-if="outline.chapterContents && outline.chapterContents.length"
          >
            <chapter-node
              v-for="(chapter, index) in outline.chapterContents"
              :key="chapter.uuid"
              :chapter="chapter"
              :index="index"
              :parent-chapters="outline.chapterContents"
              :isExpanded="isExpanded"
              @move-up="moveChapterUp"
              @move-down="moveChapterDown"
              @delete="deleteChapter"
            />
          </ul>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import ChapterNode from "./ChapterNode.vue";

export default {
  name: "OutlineTree",
  components: {
    ChapterNode,
  },
  props: {
    outlineData: {
      type: Object,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      outline: JSON.parse(JSON.stringify(this.outlineData)),
      currentChapter: "",
    };
  },
  computed: {
    outlineList() {
      return this.outline.chapterContents
        ? this.flattenChapters(this.outline.chapterContents)
        : [];
    },
  },
  watch: {
    outlineData: {
      deep: true,
      handler(newVal) {
        this.outline = JSON.parse(JSON.stringify(newVal));
      },
    },
  },
  mounted() {},
  methods: {
    flattenChapters(chapters, level = 1) {
      let result = [];
      for (const chapter of chapters) {
        if (chapter.chapterContents?.length || level === 1 || this.isExpanded) {
          // 添加当前章节
          result.push({
            chapterTitle: chapter.chapterTitle,
            level: level,
          });
        }

        // 如果有子章节，递归处理
        if (chapter.chapterContents && chapter.chapterContents.length > 0) {
          result = result.concat(
            this.flattenChapters(chapter.chapterContents, level + 1)
          );
        }
      }
      return result;
    },
    moveUp(opt) {
      this.moveChapterUp(opt);
    },
    moveDown(opt) {
      this.moveChapterDown(opt);
    },
    deleteNode(opt) {
      this.$confirm("删除后无法恢复，是否继续删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.deleteChapter(opt);
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    selectChapter(chapter) {
      this.currentChapter = chapter;
    },
    clearChapter() {
      this.currentChapter = "";
    },
    setIconStyle(level) {
      if (level === 2) {
        return {
          left: 20 * level - 15 + "px",
        };
      } else {
        return {
          left: 20 * level - 5 + "px",
        };
      }
    },
    setLineStyle(level) {
      if (level === 2) {
        return {
          left: 20 * (level - 2) + 5 * level - 5 + "px",
        };
      } else {
        return {
          left: 20 * (level - 2) + 5 * level + "px",
        };
      }
    },
    moveChapterUp({ chapter, index, parentChapters }) {
      if (index > 0) {
        // 移动当前章节及其子章节
        const prevIndex = index - 1;
        const temp = parentChapters[prevIndex];
        this.$set(parentChapters, prevIndex, chapter);
        this.$set(parentChapters, index, temp);
      }
    },
    moveChapterDown({ chapter, index, parentChapters }) {
      if (index < parentChapters.length - 1) {
        // 移动当前章节及其子章节
        const nextIndex = index + 1;
        const temp = parentChapters[nextIndex];
        this.$set(parentChapters, nextIndex, chapter);
        this.$set(parentChapters, index, temp);
      }
    },
    deleteChapter({ index, parentChapters }) {
      parentChapters.splice(index, 1);
    },
  },
};
</script>

<style lang="less" scoped>
.outline-container {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  font-family: Arial, sans-serif;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  .outline-header {
    flex: 0 0 auto;
    font-size: 28px;
    color: #333333;
    line-height: 24px;
    text-align: center;
    margin-bottom: 20px;
  }
  .chapters-tree {
    display: flex;
    flex: 1 1 auto;
    width: calc(100% - 40px);
    height: auto;
    min-width: 0;
    min-height: 0;
    box-sizing: border-box;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 20px;
    margin: 0 20px;
    .chapters-scrollbar {
      width: 100%;
      height: 100%;
      /deep/.el-scrollbar__view {
        display: flex;
        min-width: 0;
      }
      /deep/.el-scrollbar__wrap {
        height: 100%;
        overflow-x: hidden;
      }
    }
    .title-container {
      flex: 0 0 70px;
      .chapter-item {
        height: 45px;
        margin-top: 5px;
        span {
          display: inline-block;
          width: 34px;
          height: 24px;
          text-align: center;
          border-radius: 4px;
          border: 1px solid var(--primary);
          font-size: 12px;
          color: var(--primary);
          line-height: 24px;
          margin-bottom: 24px;
          &.no-border {
            border: none;
            height: 26px;
          }
        }
      }
    }
    .icon-container {
      flex: 0 0 20px;
      .icon-item {
        &:first-child {
          &::before {
            content: "";
            border-left: 1px solid #e7e7e7;
            position: absolute;
            left: 5px;
            height: 40px;
            top: 15px;
          }
        }
        &:last-child {
          &::before {
            content: "";
            border-left: 1px solid #e7e7e7;
            position: absolute;
            left: 5px;
            height: 16px;
            top: 0;
          }
        }
      }
      .icon-root {
        height: 50px;
        position: relative;
        span {
          box-sizing: border-box;
          display: inline-block;
          width: 12px;
          height: 12px;
          background: #e7e7e7;
          border-radius: 50%;
          margin-top: 11px;
        }
        &::before {
          content: "";
          border-left: 1px solid #e7e7e7;
          position: absolute;
          left: 5px;
          height: 100%;
          top: 0;
        }
      }
      .icon-chapter {
        height: 50px;
        position: relative;
        span {
          position: absolute;
          box-sizing: border-box;
          display: inline-block;
          width: 12px;
          height: 12px;
          background: #ffffff;
          border-radius: 50%;
          border: 1px solid #e7e7e7;
          margin-top: 11px;
        }
        .line {
          position: absolute;
          width: 20px;
          height: 1px;
          top: 4px;
          background: #e7e7e7;
          border: none;
        }
        &::before {
          content: "";
          border-left: 1px solid #e7e7e7;
          position: absolute;
          left: 5px;
          height: 100%;
          top: 0;
        }
      }
    }
    .tree-container {
      flex: 1;
      width: auto;
      min-width: 0;
      .chapter-item {
        margin-left: 20px;
        display: flex;
        .chapter-title {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          flex: 1;
        }
        .chapter-actions {
          .action {
            display: inline-block;
            width: 18px;
            height: 18px;
            margin: 0 6px;
            cursor: pointer;
            color: #666;
            vertical-align: middle;
          }
          .up {
            background: url(../../assets/chat/up.png) center no-repeat;
            background-size: contain;
          }
          .down {
            background: url(../../assets/chat/down.png) center no-repeat;
            background-size: contain;
          }
          .delete {
            font-size: 16px;
          }
        }
      }
      .root {
        padding-left: 4px;
      }
      /deep/.chapter-content {
        height: 36px;
        line-height: 36px;
        margin-bottom: 14px;
        padding-left: 6px;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
        &:hover {
          background: #f5f5f5;
          border-radius: 4px;
        }
      }
      /deep/.chapter-node {
        margin: 0;
        padding: 0;
      }
      /deep/ul {
        margin: 0;
        padding: 0;
        padding-left: 20px;
      }
    }
  }
}
</style>
